module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rr0oJf/tc-custom/9781595553966.jpg?1726617394418",
      "alt": "This image is the cover for the book Little Red Book of Wisdom"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Little Red Book of Wisdom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The search for wisdom invariably leads us back to the places we've overlooked.")])]), _c('b'), _c('i', [_vm._v("The Little Red Book of Wisdom")]), _vm._v(" takes the reader on a journey so often sidestepped in favor of the newer, quicker, easier.  If you're seeking simplicity in a complicated world, Mark DeMoss's insights will illuminate your path to a wiser and more deliberate way of living.  By illuminating the notions of integrity, humility, and self-restraint, DeMoss demonstrates what is possible when we value listening and thinking over talking and doing.Learn why a postage stamp is worth much more than 44 cents, and what time of day wisdom flourishes.Find out the wisest decision anyone can make, and the value of eating lunch alone.Rethink the advantages of technology, and learn how to safeguard yourself against any shadow of deathbed regret.Step out of the incessant business of your daily life, and spend a few moments learning timeless and foolproof truths that you can apply right away. Wisdom is not just for past generations; it calls to us today.  We need only respond.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark DeMoss\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0